"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryLocation = exports.getMdmIds = exports.getMdmId = exports.getCountryNames = exports.getCountryName = exports.getIso3s = exports.getIso3 = exports.getIso2s = exports.getIso2 = exports.getCountry = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const get_all_markets_1 = require("./get-all-markets");
const validateGetCountryParams = (params) => {
    if (!params.countryName && !params.mdmId && !params.iso2 && !params.iso3) {
        return false;
    }
    return true;
};
const getCountry = (params) => {
    if (!validateGetCountryParams(params)) {
        return;
    }
    const country = get_all_markets_1.allCountries.find((c) => {
        var _a, _b, _c, _d;
        return c.iso2 === ((_a = params.iso2) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
            c.iso3 === ((_b = params.iso3) === null || _b === void 0 ? void 0 : _b.toUpperCase()) ||
            c.mdmCountryId === params.mdmId ||
            ((_c = c.name) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = params.countryName) === null || _d === void 0 ? void 0 : _d.toUpperCase());
    });
    return country;
};
exports.getCountry = getCountry;
const getIso2 = (params) => {
    var _a;
    if (!!params.iso2) {
        return (0, basic_types_1.asIsoCountryCode2)(params.iso2);
    }
    return (_a = (0, exports.getCountry)(params)) === null || _a === void 0 ? void 0 : _a.iso2;
};
exports.getIso2 = getIso2;
const getIso2s = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    return supportedBrand ? get_all_markets_1.allMarkets[supportedBrand].map((m) => m.country.iso2) : undefined;
};
exports.getIso2s = getIso2s;
const getIso3 = (params) => {
    var _a;
    if (!!params.iso3) {
        return (0, basic_types_1.asIsoCountryCode3)(params.iso3);
    }
    return (_a = (0, exports.getCountry)(params)) === null || _a === void 0 ? void 0 : _a.iso3;
};
exports.getIso3 = getIso3;
const getIso3s = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    return supportedBrand ? get_all_markets_1.allMarkets[supportedBrand].map((m) => m.country.iso3) : undefined;
};
exports.getIso3s = getIso3s;
const getCountryName = (params) => {
    var _a;
    if (!!params.countryName) {
        return params.countryName;
    }
    return (_a = (0, exports.getCountry)(params)) === null || _a === void 0 ? void 0 : _a.name;
};
exports.getCountryName = getCountryName;
const getCountryNames = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    return supportedBrand ? get_all_markets_1.allMarkets[supportedBrand].map((m) => m.country.name) : undefined;
};
exports.getCountryNames = getCountryNames;
const getMdmId = (params) => {
    var _a;
    if (!!params.mdmId) {
        return params.mdmId;
    }
    return (_a = (0, exports.getCountry)(params)) === null || _a === void 0 ? void 0 : _a.mdmCountryId;
};
exports.getMdmId = getMdmId;
const getMdmIds = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    return supportedBrand
        ? get_all_markets_1.allMarkets[supportedBrand]
            .map((m) => m.country.mdmCountryId)
            .filter((id) => !!id)
        : undefined;
};
exports.getMdmIds = getMdmIds;
const getCountryLocation = (params) => {
    const validatedParams = (0, basic_types_1.asIsoCountryCode2)(params);
    const country = (0, exports.getCountry)({ iso2: validatedParams });
    if (!country) {
        return;
    }
    const location = {
        lat: country.latitude,
        lng: country.longitude,
    };
    return location;
};
exports.getCountryLocation = getCountryLocation;
